module.exports = __webpack_public_path__ + "static/Feather-ca9ce9ff0676a9b04ef0f8a3ad17dd08.ttf";